<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  #app,
  html,
  body {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
    color: #2c3e50;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }

  /* 导航栏样式 */
  .van-nav-bar {
    font-size: 18px !important;
    background-color: #f39900;
    border: 0;
    position: fixed;
    top: 0;
    left: 0;
    height: 40px;
    line-height: 46px;
    width: 100%;
    z-index: 100;
  }

  .van-nav-bar__title {
    color: #FFFFFF;
    font-size: 16px;
  }

  .van-nav-bar__text {
    color: #FFFFFF;
  }

  .van-icon-arrow-left::before {
    color: #FFFFFF;
  }

  /* 地图签到页面 */
  .mapSign .van-overlay {
    background-color: rgba(0, 0, 0, 0.1);
  }

  /* 首页 */
  /* .menu .van-overlay{
  background-color: rgba(0,0,0,0);
} */

  .mapSign .van-cell__value {
    color: blue;
  }

  .van-pull-refresh__track {
    min-height: calc(100vh - 96px);
  }

  /* 系统消息 */

  .systemMes .van-list .sys-hint {
    margin-top: 5px;
    width: 98%;
    margin-left: 1%;
  }

  .inputCarNum .van-tabs--line .van-tabs__wrap {
    width: 100%;
  }

  .modifyCarNum .van-tabs--line .van-tabs__wrap {
    width: 100%;
  }

  .inputCarNum .van-uploader__preview {
    margin-top: 16px;
  }

  /* 缴费离场 */
  .payLeave .van-grid-item__content {
    padding: 8px;
  }

  .payLeave .van-button__icon {
    font-size: 2.9em;
  }

  .take-a-picture .van-icon {
    color: #f39900;
  }

  .take-a-picture .van-uploader__upload {
    /* background-color: #f39900; */
    border: 1px solid #f39900;
  }

  /* 公众号 */
  .prePay .van-field__control {
    color: red;
    font-size: 18px;
    margin-right: 12px;
  }

  .prePay .van-field__label {
    width: 8.2em;
  }

  .advertising {
    height: 25%;
    position: relative;
  }
  .myWallet .advertising {
    height: auto;
    position: relative;
  }
  .myWallet .van-grid-item__icon{
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/App.vue